import { memo, useEffect, useState } from 'react';
import Table from '../../../components/Table/Table';
import { blockedUsersFetchAction } from '../../../store/fetchActions/blockedUsersActions';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../../../components/Filter/Filter';
import { useForm } from 'react-hook-form';
import { FirstFilterLine, SecondFilterLine } from '../../../components/Filter/Filter.styles';
import DateInput from '../../../components/DateInput';
import Button from '../../../components/Button/Button';
import { ImSearch } from 'react-icons/im';
import SelectOptions from '../../../components/SelectOptions';
import useCallFilter from '../../../utils/hooks/useCallFilter';
import ModalPassword from '../../../components/ModalPassword/ModalPassword';
import ModalBlockUser from '../components/Modals/BlockUser';
import { DesbloquearOpen } from '../../../assets/icon';
import Tooltip from '@material-ui/core/Tooltip';
import { unlockUserFetchAction } from '../../../store/fetchActions/unlockUserActions';
import formatCPFCNPJ from '../../../utils/functions/formatCPFCNPJ';
import { useTheme } from 'styled-components';
import TextField from '../../../components/TextField';
import moment from 'moment';
import Loading from '../../../components/Loading';
import { pagesOptions } from '../../../utils/constant';
import * as S from '../styles/GerenciarClientes.styles';

function UsuariosBloqueados({ value, index }) {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [isModalPasswordOpen, setIsModalPasswordOpen] = useState(false);
  const [isModalBlockUserOpen, setIsModalBlockUserOpen] = useState(false);
  const [cpfCnpjClick, setCpfCnpjClick] = useState('');
  const [filterData, setFilterData] = useState('');
  const [filter, setFilter] = useState({
    SEARCH: '',
    DATA_INICIAL: '',
    DATA_FINAL: '',
    LIMIT: 10,
    PAGE: 1,
  });
  const [dateInicial, setDateInicial] = useState(null);
  const [dateFinal, setDateFinal] = useState(moment().format('YYYY-MM-DD'));

  const { handleSubmit, control } = useForm({});

  useCallFilter(filterData, setFilter, blockedUsersFetchAction, value, index);

  useEffect(() => {
    dispatch(blockedUsersFetchAction(filter));
  }, [filter.PAGE]);

  const filterTable = (data) => {
    data.DATA_INICIAL = dateInicial ?? '';
    data.DATA_FINAL = dateFinal;
    setFilterData(data);
  };

  const openModalPassword = () => setIsModalPasswordOpen(true);
  const closeModalPassword = () => setIsModalPasswordOpen(false);

  const { blockedUsersData, paginationBlockedUsers, loadingBlockedUsers, errorBlockedUsers, errorMessageBlockedUsers } =
    useSelector((state) => state.blockedUsers);

  const header = [
    {
      id: 'data de registro',
      name: 'DATA DE REGISTRO',
      align: 'center',
    },
    {
      id: 'CPFCNPJ',
      name: 'CPF/CNPJ',
      align: 'left',
    },
    {
      id: 'nome',
      name: 'NOME',
      align: 'left',
    },
    {
      id: 'observação',
      name: 'OBSERVAÇÃO',
      align: 'left',
    },
    {
      id: 'desbloqueio',
      align: 'left',
    },
  ];

  const body = blockedUsersData?.map((user) => {
    return {
      data: [
        {
          info: user.DATA_INSERT,
          align: 'center',
        },
        {
          info: formatCPFCNPJ(user.CPFCNPJ),
          align: 'left',
        },
        {
          info: user.NOME,
          align: 'left',
        },
        {
          info: user.MENSAGEM,
          align: 'left',
        },
        {
          info: (
            <Tooltip title="Desbloquear Usuário">
              <S.ContainerReAprovedClient>
                <DesbloquearOpen
                  onClick={(e) => {
                    setCpfCnpjClick(user.CPFCNPJ), openModalPassword();
                  }}
                />
              </S.ContainerReAprovedClient>
            </Tooltip>
          ),
          align: 'left',
        },
      ],
    };
  });

  return (
    <div>
      <Filter>
        <form onSubmit={handleSubmit(filterTable)}>
          <FirstFilterLine>
            <TextField label="Nome ou CPF/CNPJ" name={'SEARCH'} width={'38.042vw'} control={control} />
            <DateInput
              label="Data Inicial"
              name={'DATA_INICIAL'}
              control={control}
              value={dateInicial}
              onChange={(newValue) =>
                newValue?.$d ? setDateInicial(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateInicial(null)
              }
            />
            <DateInput
              label="Data Final"
              name={'DATA_FINAL'}
              control={control}
              value={dateFinal}
              onChange={(newValue) =>
                newValue?.$d ? setDateFinal(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateFinal(null)
              }
            />

            <Button
              backgroundcolor={theme.colors.buttonSearch}
              width="12.153vw"
              margin={'0 1.389vw 0 0'}
              hoverbgcolor={theme.colors.buttonSearchHover}
              hovercolor={theme.colors.buttonSearchHoverText}
              mycolor={theme.colors.buttonSearchText}
              type="submit"
            >
              <ImSearch className="default-svg" size={'1.181vw'} />
              <span>Buscar</span>
            </Button>
          </FirstFilterLine>

          <SecondFilterLine>
            <h5>Resultados por página</h5>
            <SelectOptions control={control} options={pagesOptions} name={'LIMIT'} width={'5vw'} initialValue={10} />
            <h5>Total de resultados: {paginationBlockedUsers?.totalResult}</h5>
          </SecondFilterLine>
        </form>
      </Filter>
      {loadingBlockedUsers ? (
        <Loading />
      ) : (
        <Table
          loading={loadingBlockedUsers}
          error={errorBlockedUsers}
          hasPagination={true}
          filter={filter}
          pagination={paginationBlockedUsers}
          setFilter={setFilter}
          errorMessage={errorMessageBlockedUsers}
          filterTable={filterTable}
          header={header}
          body={body}
        />
      )}

      {isModalBlockUserOpen && (
        <ModalBlockUser
          openModal={isModalBlockUserOpen}
          closeModal={() => {
            setIsModalBlockUserOpen(false);
          }}
          blockUser={false}
          optionAction={unlockUserFetchAction}
          CPFUSUARIO={cpfCnpjClick}
        />
      )}

      {isModalPasswordOpen && (
        <ModalPassword
          openModal={isModalPasswordOpen}
          closeModal={closeModalPassword}
          nextFunction={() => setIsModalBlockUserOpen(true)}
        />
      )}
    </div>
  );
}

export default memo(UsuariosBloqueados);
